import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import React from "react";
var StockYears = function (props) {
    return (React.createElement("div", { className: "displayFlex justify-end mgt-2 " },
        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray text-nowrap" },
            props.stockYear && props.stockYear + "Y",
            "\u00A0",
            props.stock),
        React.createElement("span", { className: "Roboto_12_400  txt_blackOne1 mgl-5" }, (props === null || props === void 0 ? void 0 : props.reportVal) ? (React.createElement(React.Fragment, null,
            React.createElement(ReportValue, { val: props.reportVal, stream: false, onlyval: false, percentage: true }),
            React.createElement("span", null, "%"))) : ("NA"))));
};
export default StockYears;
